<template>
  <v-dialog v-model="pinDialog" persistent max-width="450" content-class="pin-dialog">
    <v-card class="pin-card">
      <CardToolbar title="Change Pin" :isModal="true" @cancel="close" />
      <v-divider></v-divider>
      <v-card-text class="pin-content">
          <v-layout column justify-center align-center class="my-1">
            <v-flex shrink>
              <v-row>
                <v-col v-for="circle in pinCodeCircles" :key="circle">
                  <v-icon x-large :color="pinColor(circle)">{{ pinCodeStyle(circle) }}</v-icon>
                </v-col>
              </v-row>
            </v-flex>
            <v-col class="mt-5">
              <v-row justify="center" fill-height style="height: 100%">
                <v-col
                  v-for="num in numbers"
                  :key="num"
                  class="col-4 text-center pin-key-cell"
                >
                  <v-btn fab height="72" @pointerdown.stop.prevent="pointerMode && selectedNum(num)"
                    @click.stop.prevent="!pointerMode && selectedNum(num)" width="72" class="pin-key">
                    <span class="text-h3">{{ num }}</span>
                  </v-btn>
                </v-col>
                <v-col class="col-8 text-center">
                    <v-btn height="72" block rounded @pointerdown.stop.prevent="pointerMode && selectedNum(0)"
                      @click.stop.prevent="!pointerMode && selectedNum(0)" class="pin-key">
                      <span class="text-h3">0</span>
                    </v-btn>
                  </v-col>
                  <v-col class="col-4 text-center">
                    <v-btn height="72" block rounded @pointerdown.stop.prevent="pointerMode && clearPin()"
                      @click.stop.prevent="!pointerMode && clearPin()" class="pin-clear">
                      <span class="text-h3">C</span>
                    </v-btn>
                  </v-col>
              </v-row>
            </v-col>
          </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["dialog"],
  data: () => ({
    pinDialog: false,
    pinCodeCircles: [1, 2, 3, 4],
    pin: "",
    numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9],
    pointerMode: "PointerEvent" in window,
  }),
  watch: {
    dialog(val){
      this.pinDialog = val
    },
    pin() {
      // Reseting Pin
      if (this.pin.length === 5) {
        this.pin = "";
      }

      // Submiting
      if (this.pin.length === 4) {
        this.pinSubmit(this.pin);
      }
    },
  },
  methods: {
    pinColor(num) {
      if (this.pin.length >= num) {
        return "secondary";
      }
      else {
        return "grey";
      }
    },
    pinCodeStyle(num) {
      if (this.pin.length >= num) {
        return "mdi-check-circle";
      }
      else {
        return "mdi-checkbox-blank-circle-outline";
      }
    },
    selectedNum(num) {
      num = num.toString();
      this.pin = this.pin.concat(num).trim();
    },
    pinSubmit(val) {
      this.pin = val;
      this.$emit('submit', this.pin)
      this.clearPin();
    },
    clearPin() {
      this.pin = ""
    },
    close(){
      this.pin = "",
      this.$emit('close')
    }
  },
}
</script>
<style scoped>
.pin-card { background: var(--v-surface-base) !important; border: 1px solid var(--v-border-base); }
.pin-content { background: var(--v-surface-base); padding: 24px !important; }
.pin-key-cell { padding: 8px; }
.pin-key {
  background: var(--v-surfaceMuted-base) !important;
  border: 1px solid var(--v-border-base);
  color: var(--v-textPrimary-base) !important;
  box-shadow: 0 7px 16px rgba(4, 15, 30, 0.18) !important;
}
.pin-clear {
  background: rgba(251, 113, 133, 0.12) !important;
  border: 1px solid var(--v-error-base);
  color: var(--v-error-base) !important;
}
.pin-content ::v-deep .v-icon { color: var(--v-border-base); }
.pin-content ::v-deep .v-icon.secondary--text { color: var(--v-primary-base) !important; }
@media (max-width: 480px) {
  .pin-content { padding: 18px 12px !important; }
  .pin-key-cell { padding: 6px; }
}
</style>
